import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-ramp-right', 'IconArrowRampRight', [
  ['path', { d: 'M7 3l0 8.707', key: 'svg-0' }],
  ['path', { d: 'M11 7l-4 -4l-4 4', key: 'svg-1' }],
  ['path', { d: 'M17 14l4 -4l-4 -4', key: 'svg-2' }],
  ['path', { d: 'M7 21a11 11 0 0 1 11 -11h3', key: 'svg-3' }],
]);
